import { useState } from "react";

export default function AdminLogin() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [status, setStatus] = useState("");

    const handleLogin = async () => {
        try {
            const res = await fetch(`${import.meta.env.VITE_API_URL}/api/admin-login`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            if (!res.ok) throw new Error("Login failed");
            setStatus("Logged in!");
            window.location.href = "/admin";
        } catch {
            setStatus("Invalid credentials");
        }
    };

    return (
        <div className="p-4 max-w-sm mx-auto">
            <h1 className="text-xl font-bold mb-4">Admin Login</h1>
            <input
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="border p-2 w-full mb-2"
            />
            <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="border p-2 w-full mb-2"
            />
            <button onClick={handleLogin} className="bg-blue-600 text-white w-full py-2">
                Login
            </button>
            <p className="mt-2 text-red-500">{status}</p>
        </div>
    );
}
